/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

export const menuItems = [
  { name: "Home", href: "#", hash: "" },
  // { name: "About", href: "#about", hash: "#about" },
  { name: "Experience", href: "#experience", hash: "#experience" },
  { name: "Skillset", href: "#skillset", hash: "#skillset" },
  { name: "Certifications", href: "#certifications", hash: "#certifications" },
  { name: "Side Projects", href: "#projects", hash: "#projects" },
  // { name: "Contact", href: "#contact", hash: "#contact" },
];
